import { IClassState } from './IClassState';
export const initialState: IClassState = {
  data: null,
  attendance: null,
  participationData: [],
  searchField: '',
  sortStudentBy: 'sortAscFirstName',
  allSuggestedActivities: [],
};
